"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrushShader = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const standard_vert_1 = __importDefault(require("./glsl/standard.vert"));
const pixi_js_1 = require("pixi.js");
const globalUniforms = {
    uTime: 0.0,
    uResolution: new pixi_js_1.Point(1, 1)
};
// Fix for some shaders on Android (and apparently some on iOS too)
pixi_js_1.Program.defaultFragmentPrecision = pixi_js_1.PRECISION.HIGH;
class BrushShader {
    constructor(frag, uniforms) {
        this.ticker = new pixi_js_1.Ticker();
        this._uniforms = Object.assign(Object.assign({}, globalUniforms), uniforms);
        this._filter = new pixi_js_1.Filter(null, frag, this._uniforms);
        const program = this.makeProgram(frag);
        this._shader = new pixi_js_1.Shader(program, this._uniforms);
        let startTime = 0;
        this.ticker.add((delta) => {
            startTime += delta;
            this._uniforms.uTime = startTime;
        });
        this.ticker.start();
    }
    makeProgram(frag) {
        return pixi_js_1.Program.from(standard_vert_1.default, frag);
    }
    get uniforms() {
        return this._uniforms;
    }
    get filter() {
        return this._filter;
    }
    get shader() {
        return this._shader;
    }
    destroy() {
        this.ticker.destroy();
        this._filter.destroy();
        this._shader.destroy();
    }
}
exports.BrushShader = BrushShader;
